"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _qs = _interopRequireDefault(require("qs"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _contentType = require("@insided/shared/utils/contentType");

var _Content = require("@insided/destination/modules/Content");

var _TopicContainer = _interopRequireDefault(require("@insided/destination/modules/Content/TopicList/TopicContainer"));

var _PostActionsDropdown = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/PostActionsDropdown"));

var _MarkAsSpamModal = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/MarkAsSpamModal"));

var _TrashModal = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/TrashModal"));

var _topicService = require("@insided/shared/services/topicService");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var _TopicFooter = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicFooter"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _utils = require("@insided/destination/modules/Content/TopicList/utils");

var _userContext = require("../../server-middleware/userContext");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _StickyFlag = _interopRequireDefault(require("@insided/destination/icons/StickyFlag"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _UserName = _interopRequireDefault(require("../User/UserName"));

var _TopicLabel = _interopRequireDefault(require("./TopicLabel"));

var _IdeationStatus = _interopRequireDefault(require("./IdeationStatus"));

var _TopicContent = _interopRequireWildcard(require("./TopicContent"));

var _StatusPill = _interopRequireDefault(require("@insided/shared/uikit/StatusPill"));

var _common = require("@insided/shared/utils/common");

var _globals = require("@insided/shared/utils/globals");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'topic-list-item';
exports.cssAnchorName = cssAnchorName;

var getMetadataForTopicType = function getMetadataForTopicType(topicType, contentType) {
  if (topicType === 'ideation') {
    return (0, _preact.h)(_phrase.default, {
      p: "topic.list.metadata.shared.in"
    });
  } else {
    if (contentType === 'article') {
      return (0, _preact.h)(_phrase.default, {
        p: "topic.list.metadata.published.in"
      });
    } else if (contentType === 'question') {
      return (0, _preact.h)(_phrase.default, {
        p: "topic.list.metadata.asked.in"
      });
    }

    return (0, _preact.h)(_phrase.default, {
      p: "topic.list.metadata.posted.in"
    });
  }
};

var featuredImageComponent = function featuredImageComponent(featuredImage, attachmentCdn, altText, topicTitle) {
  return (0, _preact.h)(_LazyImage.default, {
    type: "img",
    src: (0, _absoluteUrlRuntime.resolveUrl)((0, _TopicContent.getImageUrl)(featuredImage, '480', attachmentCdn)),
    className: "thread-list-block__featured-image-link topic-image",
    alt: altText,
    title: topicTitle
  });
};

var TopicListItemView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListItemView, _Component);

  var _super = _createSuper(TopicListItemView);

  function TopicListItemView(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopicListItemView);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showMarkAsSpamModal: false,
      showTrashModal: false,
      alert: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFavoriteRemoval", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios.default.post('/favorite/delete', _qs.default.stringify({
                yip_csrf_token: _this.props.csrfToken,
                threadid: _this.props.topic.id
              }));

            case 2:
              if (_this.ref) {
                _this.ref.classList.add('remove-favorite');

                setTimeout(function () {
                  if (_this.ref) {
                    var _this$ref$parentNode, _this$ref$parentNode$;

                    (_this$ref$parentNode = _this.ref.parentNode) === null || _this$ref$parentNode === void 0 ? void 0 : (_this$ref$parentNode$ = _this$ref$parentNode.parentNode) === null || _this$ref$parentNode$ === void 0 ? void 0 : _this$ref$parentNode$.removeChild(_this.ref.parentNode); // Remove `date-preact` component
                  }
                }, 250);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMarkAsSpamModal", function (show) {
      _this.setState({
        showMarkAsSpamModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showTrashModal", function (show) {
      _this.setState({
        showTrashModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAlert", function (type, message) {
      _this.setState({
        alert: {
          type: type,
          message: typeof message === 'string' ? (0, _preact.h)(_phrase.default, {
            p: message
          }) : message !== null && message !== void 0 ? message : (0, _preact.h)(_phrase.default, {
            p: "topic_view.reported_content_modal.error"
          })
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStatusBadge", function () {
      var topic = _this.props.topic;
      var contentType = topic.contentType;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      if (contentType === 'idea') {
        return (0, _preact.h)(_IdeationStatus.default, {
          topic: topic
        });
      }

      if ((0, _contentType.isConversationOrDiscussion)(contentType) && isBugContentTypeEnabled && topic !== null && topic !== void 0 && topic.bugStatus) {
        var bugStatus = topic.bugStatus;
        return (0, _preact.h)(_StatusPill.default, {
          label: bugStatus.name,
          backgroundColor: bugStatus.backgroundColor,
          textColor: bugStatus.textColor
        });
      }

      return (0, _preact.h)(_Content.TopicTooltip, {
        topic: topic
      });
    });
    _this.ref = null;
    return _this;
  }

  (0, _createClass2.default)(TopicListItemView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          topic = _this$props.topic,
          attachmentCdn = _this$props.attachmentCdn,
          hideCategoryMetadata = _this$props.hideCategoryMetadata,
          clickCallback = _this$props.clickCallback,
          showUnsubscribeBtn = _this$props.showUnsubscribeBtn,
          isActivityPage = _this$props.isActivityPage,
          ariaKey = _this$props.ariaKey,
          isFrontendModerationEnabled = _this$props.isFrontendModerationEnabled;
      var privateId = topic.privateId,
          type = topic.type,
          contentType = topic.contentType,
          isSticky = topic.isSticky,
          relevantPost = topic.relevantPost,
          topicUrl = topic.url,
          featuredImage = topic.featuredImage,
          featuredImageAltText = topic.featuredImageAltText,
          topicTitle = topic.title,
          firstPost = topic.firstPost,
          forum = topic.forum,
          lastPost = topic.lastPost,
          isTopicUnread = topic.isTopicUnread,
          isUnreadPostCountEnabled = topic.isUnreadPostCountEnabled,
          closed = topic.closed;
      if (!firstPost) return null;
      var author = firstPost.author;
      var userTitle = author.userTitle;
      var forumUrl = forum.url,
          forumTitle = forum.title;
      var topicCategoryMetadata = getMetadataForTopicType(type, contentType);
      var redirectUrl = isActivityPage ? relevantPost.url : topic.url;

      var parsedTopicTitle = _htmlParser.default.stripHtml(topicTitle);

      var _this$state = this.state,
          showMarkAsSpamModal = _this$state.showMarkAsSpamModal,
          showTrashModal = _this$state.showTrashModal,
          alert = _this$state.alert;
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        return (0, _preact.h)(_userContext.CurrentUserContext.Consumer, null, function (user) {
          return (0, _preact.h)("div", {
            className: (0, _classnames.default)('qa-topic-block', 'topic-view', 'js-thread', "js-thread-id-".concat(topic.id), {
              'topic-view--unread': isUnreadPostCountEnabled && isTopicUnread,
              'topic-view--sticky': isSticky,
              'topic-view--ideation': type === 'ideation',
              'topic-view--bug': _common.common.isModuleActive('bugContentType') && (0, _contentType.isConversationOrDiscussion)(contentType)
            }),
            ref: function ref(_ref4) {
              _this2.ref = _ref4;
            }
          }, isFrontendModerationEnabled ? (0, _preact.h)("div", {
            className: "topic-view__action-bar"
          }, isSticky && (0, _preact.h)(_StickyFlag.default, {
            className: "topic-view_sticky-flag",
            height: 24,
            width: 24,
            viewBox: "0 0 24 24"
          }), (0, _preact.h)(_PostActionsDropdown.default, {
            menuOptions: (0, _utils.extraMenuItems)({
              privateId: privateId,
              contentType: (0, _contentType.getConsistentContentType)(contentType),
              isSticky: isSticky,
              isClosed: closed,
              onShowAlert: _this2.handleShowAlert,
              showMarkAsSpamModal: _this2.showMarkAsSpamModal,
              showTrashModal: _this2.showTrashModal
            })
          })) : isSticky && (0, _preact.h)(_StickyFlag.default, {
            className: "topic-view_sticky-flag"
          }), (0, _preact.h)("div", {
            className: "topic-view_header"
          }, (0, _preact.h)("div", {
            className: "topic-view_header-item"
          }, (0, _preact.h)(_UserAvatar.default, {
            user: author,
            extraClass: "avatar",
            showRank: true
          })), (0, _preact.h)("div", {
            className: (0, _classnames.default)('topic-view_header-items-gathered', {
              'topic-view_header-items_without-category': hideCategoryMetadata || !forumTitle
            })
          }, (0, _preact.h)("div", {
            className: "topic-view_header-item"
          }, (0, _preact.h)(_UserName.default, {
            user: author,
            extraClass: "username"
          }), userTitle && (0, _preact.h)("span", {
            className: "user-title text--meta"
          }, userTitle)), !hideCategoryMetadata && !!forumTitle && (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)(forumUrl),
            "data-track-type": "click",
            "data-element-name": "Search result topic header link",
            className: "topic-view_header-item text--meta"
          }, (0, _preact.h)("span", null, topicCategoryMetadata), "\xA0", (0, _preact.h)("span", {
            className: "topic-view_header-item_category-link"
          }, modules.includes('categoriesAsPhrases') ? (0, _preact.h)(_phrase.default, {
            p: forumTitle
          }) : forumTitle)))), (0, _preact.h)("div", null, (0, _preact.h)(_TopicContainer.default, {
            anchorProps: {
              id: ariaKey,
              href: topicUrl,
              className: 'qa-topic-title'
            },
            clickCallback: clickCallback,
            infoSlot: featuredImage && featuredImageComponent(featuredImage, attachmentCdn, featuredImageAltText, topicTitle)
          }, (0, _preact.h)("div", {
            className: "thread-list-block__title"
          }, (0, _preact.h)("span", {
            className: "thread-list-block__title-link"
          }, parsedTopicTitle), (0, _preact.h)(_TopicLabel.default, {
            topic: topic
          }), _this2.renderStatusBadge()), (0, _preact.h)(_TopicContent.default, {
            topic: _objectSpread(_objectSpread({}, topic), {
              url: redirectUrl
            })
          })), (0, _preact.h)(_TopicFooter.default, {
            topic: topic,
            lastPost: lastPost,
            showUnsubscribeBtn: showUnsubscribeBtn,
            handleFavoriteRemoval: _this2.handleFavoriteRemoval,
            userId: user.id,
            extraSpacing: true
          })), showMarkAsSpamModal && (0, _preact.h)(_MarkAsSpamModal.default, {
            title: "frontend_moderation.mark_topic_as_spam",
            subTitle: "frontend_moderation.spam_topic_warning",
            isOpen: showMarkAsSpamModal,
            onClose: function onClose() {
              return _this2.showMarkAsSpamModal(false);
            },
            onMarkAsSpam: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 3;
                      return (0, _topicService.markTopicAsSpam)((0, _contentType.getConsistentContentType)(contentType), topic.privateId);

                    case 3:
                      _this2.handleShowAlert('success', (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.topic_marked_as_spam"
                      }));

                      _this2.showMarkAsSpamModal(false);

                      window.location.reload();
                      _context2.next = 12;
                      break;

                    case 8:
                      _context2.prev = 8;
                      _context2.t0 = _context2["catch"](0);

                      _logger.logger.error(_context2.t0, {
                        component: 'TopicListItemView',
                        action: 'onMarkAsSpam'
                      });

                      _this2.handleShowAlert('error', (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.error_while_marking_topic_as_spam"
                      }));

                    case 12:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[0, 8]]);
            }))
          }), showTrashModal && (0, _preact.h)(_TrashModal.default, {
            title: "frontend_moderation.trash_the_topic",
            subTitle: "frontend_moderation.trash_topic_warning",
            isOpen: showTrashModal,
            onClose: function onClose() {
              return _this2.showTrashModal(false);
            },
            onTrash: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      _context3.next = 3;
                      return (0, _topicService.toggleTrashed)((0, _contentType.getConsistentContentType)(contentType), topic.privateId, true);

                    case 3:
                      _this2.handleShowAlert('success', (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.topic_trashed"
                      }));

                      _this2.showTrashModal(false);

                      window.location.reload();
                      _context3.next = 12;
                      break;

                    case 8:
                      _context3.prev = 8;
                      _context3.t0 = _context3["catch"](0);

                      _logger.logger.error(_context3.t0, {
                        component: 'TopicListItemView',
                        action: 'onTrash'
                      });

                      _this2.handleShowAlert('error', (0, _preact.h)(_phrase.default, {
                        p: "frontend_moderation.error_while_trashing_topic"
                      }));

                    case 12:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[0, 8]]);
            }))
          }), (alert === null || alert === void 0 ? void 0 : alert.message) && (0, _preact.h)(_AlertComponent.default, {
            sticky: true,
            messageType: alert.type,
            isVisibleFor: 3000,
            onTimeoutEnd: function onTimeoutEnd() {
              return _this2.setState({
                alert: undefined
              });
            }
          }, alert.message));
        });
      });
    }
  }]);
  return TopicListItemView;
}(_preact.Component);

var _default = TopicListItemView;
exports.default = _default;